var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconWrench = function SvgIconWrench(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.012 7.793C13.4408 8.36544 12.7126 8.75562 11.9196 8.91422C11.1266 9.07282 10.3044 8.9927 9.55698 8.684L4.68798 14.552C3.79698 15.443 2.35698 15.443 1.46598 14.552C0.574979 13.661 0.574979 12.221 1.46598 11.339L7.33398 6.461C6.72198 4.976 7.01898 3.212 8.22498 2.006C9.37698 0.853998 11.033 0.547998 12.473 1.052L9.87198 3.653L12.41 6.191L14.984 3.608C15.461 5.03 15.146 6.659 14.012 7.793ZM2.42898 13.589C2.78898 13.94 3.36498 13.94 3.71598 13.589C4.07598 13.229 4.07598 12.653 3.71598 12.302C3.36498 11.942 2.78898 11.942 2.42898 12.302C2.26024 12.4737 2.16568 12.7048 2.16568 12.9455C2.16568 13.1862 2.26024 13.4173 2.42898 13.589Z",
    fill: "#000A4E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconWrench, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-wrench.a32264bb.svg";
export { ForwardRef as ReactComponent };